import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Container, Grid, Typography, TextField, Hidden } from '@material-ui/core';
import CreditCardPayment from '../components/CreditCardPayment';
import { genfunction } from '../../../helpers';
import { actionAddGiftCardHold, actionResetGiftCardHoldState, actionRecalculateGiftCardHold } from 'actions';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { useDispatch, useSelector } from 'react-redux';
import { actionShopCardAddGiftCard, actionShopCartSetMmbAmountToPay, actionShopCartSetEnteredAmountToPay } from 'actions';
import { withRouter } from 'react-router';
import { actionStartAppLoader, actionEndAppLoader } from '../../../actions/actionAppLoader';
import PayableCardMMB from '../../../views/Checkout/components/PayableCardMMB';
const { AmountToPayLength, Currency } = window['runConfig'];


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    }, tourheaderboxMobView: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '80px'
    }, hideGrid: {
        display: 'none'
    }
}));

const MakePayment = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [giftCardno, setgiftCardno] = useState("");
    const [errormsg, seterrormsg] = useState("");
    const { GiftCardHold, GiftCardHoldLoading, GiftCardHoldError } = useSelector(state => state.reducerGiftCardHold);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
    const currentDateEvent = useSelector(state => state.reducerExtraItems.extraItem);
    const managebkngTicketsModify = useSelector(state => state.reducerShopCart.managebookingticketsmodification);
    const cartEvents = useSelector(state => state.reducerShopCart.events);
    let shopcartamounttoPay = useSelector(state => state.reducerShopCart.mmbAmountToPay);
    let refundType = useSelector(state => state.reducerShopCart.refundType);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    let enteredAmountToPay = useSelector(state => state.reducerShopCart.enteredAmountToPay);

    const [amounttopayTxtBox, setamounttopayTxtBox] = useState(0);

    let amountaftercoupon = genfunction.subproducttotal(cartEvents, null, null, null, null, null, null, [], []);

    const CheckGiftCard = (giftcardNo) => {
        if (shopcartamounttoPay <= 0) {
            seterrormsg('Please add item in cart before applying Giftcard.')
        }
        else if (giftCardno == '') {
            seterrormsg('Please enter Giftcard number.')
        }
        else {
            actionShopCartSetMmbAmountToPay(dispatch, shopcartamounttoPay);
            actionAddGiftCardHold(dispatch, giftcardNo);
            setgiftCardno('');
        }
    }

    const errorcancelhandle = () => {
        actionResetGiftCardHoldState(dispatch);
        setgiftCardno('');
        seterrormsg('');
    }

    const openerrorpopup = () => {
        return (errormsg != "")
    }


    //Gift Card Handling

    useEffect(() => {
        seterrormsg(GiftCardHoldError)
    }, [GiftCardHoldError]);

    useEffect(() => {
        if (GiftCardHoldLoading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [GiftCardHoldLoading]);

    useEffect(() => {
        if (GiftCardHold.GiftcardHoldRef)
            ValidateAndAddGiftCard(GiftCardHold)
    }, [GiftCardHold]);

    const ValidateAndAddGiftCard = (giftcardholdresponse) => {
        if (giftcardholdresponse.HoldAmount == 0) {
            seterrormsg('Giftcard is already consumed');
        }
        else {
            actionShopCardAddGiftCard(dispatch, giftcardholdresponse);
            actionResetGiftCardHoldState(dispatch);
        }
    }
    useEffect(() => {
        let total;
        let isTransFeeApplicable = showTransFee && transactionfee.transactionFee[0] && transactionfee.transactionFee[0].PriceIsAPercentage ? transactionfee.transactionFee[0] : undefined;

        if (cashlesstotal > 0 && isTransFeeApplicable) {
            total = AmountToPayCalCulation();
            if (parseFloat(total) === 0)
                actionShopCartSetMmbAmountToPay(dispatch, enteredAmountToPay);
            else
                actionShopCartSetMmbAmountToPay(dispatch, genfunction.AddCashlessAndAdditionalPayment(cashless, parseFloat(total)));
        }

    }, [cashless]);

    useEffect(() => {
        RecalculationGiftCard();
    }, [showTransFee])

    const RecalculationGiftCard = () => {
        if (enteredAmountToPay > 0 && cashless.length > 0) {
            actionRecalculateGiftCardHold(dispatch);
        }
    }

    const totalpaid = () => {
        let total = 0;
        let actualTotal = 0;
        let newTotal = 0;
        let eventTotal = cartEvents && cartEvents.length ? amountaftercoupon : currentDateEvent.TotalAmount ? currentDateEvent.TotalAmount : 0;

        if (props.booking && props.booking && props.booking.BookingPayments && props.booking.BookingPayments.length > 0 && props.booking.BookingProducts
            && props.booking.BookingProducts.length > 0) {

            actualTotal = props.booking.BookingProducts.map(({ ProductLinePriceInclTax }) => ProductLinePriceInclTax).reduce((sum, i) => sum + i, 0);
            if (managebkngTicketsModify) {
                props.booking.BookingProducts.map(prod => {
                    if (prod.hasOwnProperty('isModify') && prod.isModify) {
                        newTotal += prod.newQuantity * prod.Price;
                    }
                    else {
                        newTotal += prod.ProductLinePriceInclTax;
                    }
                })
            }
            total = parseFloat(((actualTotal - newTotal) * 100) / 100);
        }

        return (eventTotal - total).toFixed(2);

    }

    const totalbookingcost = () => {
        let total = 0;
        if (props.booking && props.booking.hasOwnProperty('BookingProducts') && props.booking.BookingProducts.length > 0) {
            total = props.booking.BookingProducts.map(({ ProductLinePriceInclTax }) => ProductLinePriceInclTax).reduce((sum, i) => sum + i, 0);
        }

        return total;
    }

    const totalbookingpaid = () => {
        let totalpaid = 0;

        if (props.booking && props.booking.hasOwnProperty('BookingPayments') && props.booking.BookingPayments.length > 0) {
            totalpaid = props.booking.BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
        }

        return totalpaid;
    }

    useEffect(() => {
        if (managebkngTicketsModify || refundType === 'AdditionalPayment' || (refundType === "" && shopcartamounttoPay > 0)) {
            setamounttopayTxtBox(parseFloat(enteredAmountToPay > 0 ? enteredAmountToPay : shopcartamounttoPay).toFixed(2));
            actionShopCartSetMmbAmountToPay(dispatch, genfunction.Rounded(shopcartamounttoPay));
        }
        else {

            setamounttopayTxtBox(parseFloat(totalpaid()));
            actionShopCartSetMmbAmountToPay(dispatch, parseFloat(totalpaid()));
        }
    }, []);

    useEffect(() => {
        actionShopCartSetEnteredAmountToPay(dispatch, parseFloat(amounttopayTxtBox));
    }, [amounttopayTxtBox])

    const amounttopayTxtUpdate = (event) => {

        let totalcst = totalbookingcost();
        let totalpd = totalbookingpaid();
        let txtBoxValue = parseFloat(event.target.value);

        if (txtBoxValue > 0 && (txtBoxValue <= genfunction.Rounded(totalcst - totalpd))) {

            setamounttopayTxtBox(genfunction.Rounded(txtBoxValue));

            let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], txtBoxValue, cashlesstotal);
            actionShopCartSetMmbAmountToPay(dispatch, showTransFee ? genfunction.Rounded(txtBoxValue + transFee) : genfunction.Rounded(txtBoxValue));
        }
        else {
            setamounttopayTxtBox(0);
            actionShopCartSetMmbAmountToPay(dispatch, 0);
        }
    }

    const AmountToPayCalCulation = () => {
        let total = 0;
        if (refundType === "GiftCardRefund" || refundType === "CreditCardRefund" || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund") {
            total = shopcartamounttoPay;
        }
        else if (refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0)) {

            if (showTransFee) {

                let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal);
                total = genfunction.Rounded(enteredAmountToPay + transFee) - cashlesstotal;

            }
            else {

                total = enteredAmountToPay - cashlesstotal;
            }

        }
        else {
            total = shopcartamounttoPay - cashlesstotal;
        }

        return parseFloat(total).toFixed(2);
    }

    return (

        //Desktop and Laptop (smDown)
        //Tablet (xsDown mdUp)
        //Mobile (smUp)

        <Container className={classes.root}>
            <ErrorHandling msg={errormsg} open={openerrorpopup()} handleclose={errorcancelhandle} />

            <Grid container justify="center" spacing={1} >
                <Grid item xs={12} md={7}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: 5 }}>
                            {props.booking !== undefined && props.booking.hasOwnProperty('BookingName') ? props.booking.BookingName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: 7 }}>
                            {props.booking !== undefined && props.booking.hasOwnProperty('BookingName') ? props.booking.BookingName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: 10, marginTop: 10, height: 'auto' }}>
                            {props.booking !== undefined && props.booking.hasOwnProperty('BookingName') ? props.booking.BookingName : ''}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" align="center" style={{ padding: "10px" }}>
                            Make Payment for Booking ID {props.booking && props.booking.hasOwnProperty('BookingID') ? props.booking.BookingID : 0}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" align="center" style={{ padding: "10px" }}>
                            Make Payment for Booking ID {props.booking && props.booking.hasOwnProperty('BookingID') ? props.booking.BookingID : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" align="center" style={{ padding: "10px" }}>
                            Make Payment for Booking ID {props.booking && props.booking.hasOwnProperty('BookingID') ? props.booking.BookingID : 0}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Total : {genfunction.ccyFormat(totalbookingcost())}
                        </Typography>
                    </Hidden>

                    <Hidden smDown>
                        <Typography variant="h4" style={{ padding: "10px" }}>
                            Total Paid : {genfunction.ccyFormat(totalbookingpaid())}
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography variant="h5" style={{ padding: "10px" }}>
                            Total Paid : {genfunction.ccyFormat(totalbookingpaid())}
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography variant="h6" style={{ padding: "10px" }}>
                            Total Paid : {genfunction.ccyFormat(totalbookingpaid())}
                        </Typography>
                    </Hidden>

                    <Grid item xs={12} md={12} style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}>

                        <Hidden smDown>
                            <Typography variant="h4" style={{ padding: "10px" }}>
                                Amount to Pay :
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography variant="h5" style={{ padding: "10px" }}>
                                Amount to Pay :
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography variant="h6" style={{ padding: "10px" }}>
                                Amount to Pay :
                            </Typography>
                        </Hidden>


                        {Currency}<TextField
                            onChange={amounttopayTxtUpdate}
                            style={{ padding: "10px" }}
                            id="amounttoPay"
                            name="amounttoPay"
                            type="number"
                            inputProps={{ maxLength: AmountToPayLength }}
                            value={amounttopayTxtBox}
                            disabled={refundType !== 'AdditionalPayment'}
                        /></Grid>
                </Grid>

                <Grid item xs={12} md={7} className={refundType === "CreditCardRefund" ? classes.hideGrid : ''}>
                    <Hidden smDown>
                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: 5 }}>
                            Apply a Gift Card
                        </Typography>
                    </Hidden>

                    <Hidden xsDown mdUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h3" style={{ padding: 7 }}>
                            Apply a Gift Card
                        </Typography>
                    </Hidden>

                    <Hidden smUp>
                        <Typography className={classes.tourheaderbox} align="center" variant="h4" style={{ padding: 10 }}>
                            Apply a Gift Card
                        </Typography>
                    </Hidden>




                    <Grid item xs={12} md={12} align="center" style={{ marginTop: "15px" }}>
                        <TextField
                            margin="dense"
                            id="giftcard"
                            name="giftcard"
                            label="Enter Gift Card Number"
                            type="text"
                            value={giftCardno}
                            onChange={event => {
                                setgiftCardno(event.target.value);
                            }}
                        />

                        <Hidden smDown>
                            <Button variant="contained" size="large" color="primary"
                                style={{ marginTop: "8px", marginLeft: "10px" }}
                                onClick={() => { CheckGiftCard(giftCardno) }}
                                disabled={parseFloat(AmountToPayCalCulation()) === 0 || refundType == "GiftCardRefund" || refundType === "CreditCardRefund" || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund"}
                            >
                                Apply
                            </Button>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Button variant="contained" size="medium" color="primary"
                                style={{ marginTop: "14px", marginLeft: "10px" }}
                                onClick={() => { CheckGiftCard(giftCardno) }}
                                disabled={refundType == "GiftCardRefund" || refundType === "CreditCardRefund" || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund"}
                            >
                                Apply
                            </Button>
                        </Hidden>

                        <Hidden smUp>
                            <Button variant="contained" size="small" color="primary"
                                style={{ marginTop: "20px", marginLeft: "10px" }}
                                onClick={() => { CheckGiftCard(giftCardno) }}
                                disabled={refundType == "GiftCardRefund" || refundType === "CreditCardRefund" || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund"}
                            >
                                Apply
                            </Button>
                        </Hidden>


                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <PayableCardMMB AmountToPay={AmountToPayCalCulation()} />
                </Grid>

                <CreditCardPayment
                    onClickHandler={props.onClickHandler}
                    booking={props.booking}
                    amounttopay={AmountToPayCalCulation()}
                    refundType={refundType}
                />
            </Grid>
        </Container >
    );
};

export default withRouter(MakePayment);
